angular.module('eventTimeSaleWashDirect', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/event-time-sale-wash-direct/event-time-sale-wash-direct.module.js